import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconElement = styled(FontAwesomeIcon)`
  transition: all 0.15s ease-in-out;

  :hover {
    cursor: ${(props) => props.onClick && 'pointer'};
    color: ${(props) => (props.hovercolor ? props.hovercolor : null)};
  }
`;

/**
 * Generic Icon For Font-Awesome Icons
 *
 * Learn how to use this component:
 * https://www.npmjs.com/package/@fortawesome/react-fontawesome#features
 *
 */
const Icon = ({
  id,
  size,
  icon,
  color,
  extraProps = {},
  onClick,
  hoverColor,
}) => (
  <IconElement
    data-testid={id || 'icon'}
    icon={icon}
    color={color}
    size={size}
    onClick={onClick}
    hovercolor={hoverColor}
    {...extraProps}
  />
);

Icon.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.any,
  extraProps: PropTypes.object,
  onClick: PropTypes.func,
  hoverColor: PropTypes.string,
};

export default React.memo(Icon);
